import { Component, Prop, Vue } from 'vue-property-decorator'
import { FieldMappingServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import '../index.less'
import CreatModal from './CreatModal.vue'
const fmsp = new FieldMappingServiceProxy()

@Component({
  components: {
    CreatModal
  }
})
export default class FieldMappingDetail extends Vue {
  @Prop({ default: ""}) readonly menuKey: String
  @Prop({ default: ""}) readonly searchValue: String
  @Prop({ default: () => []}) readonly data: Array<any>
  @Prop({ default: 0}) readonly total: Number
  @Prop({ default: false}) readonly loading: Boolean
  @Prop({ default: () => ({})}) readonly filters: any

  get columns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'id',
        key: 'id',
        width:150,
        customRender: (_,record) => {
          return (
            record.id &&
            <div style="">
              <a
                type="link"
                v-acl="page_system_coding_rules_application_object_edit"
                onClick={(e) => {
                  e.stopPropagation();
                  this.openEdit(record);
                }}
              >
                {this.$t("edit")}
              </a>
              <a-divider type="vertical" />
              <a
                type="link"
                v-acl="page_system_coding_rules_application_object_delete"
                style="color: #fa554c"
                onClick={(e) => {
                  e.stopPropagation();
                  this.deleteId(record.id);
                }}
              >
                {this.$t("delete")}
              </a>
            </div>
          );
        },
      },
      {
        title: this.$t('page_ops_customer_matching_content'),
        dataIndex: 'name',
        key: 'name',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_ops_customer_corresponding_content'),
        dataIndex: 'code',
        key: 'code',
        ellipsis: true
      },
    ]
  };
  selectedRowKeys = []
  dataList = []
  creatVisible = false
  editData = {}
  cilentHeight = 330
  mmTitle = ''

  updated(){
    const div = document.querySelector('#rules-table')
    if(div !== null){
      this.cilentHeight = div.clientHeight - 140
    }
  };

  onSelectChange(value){
    this.selectedRowKeys = value
  }

  pageIndexchange(value){
    this.$emit('sizeChange',value)
  }

  onSearch(value){
    this.$emit('search',value)
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  delete(){
    const ids = this.selectedRowKeys.join(",")
    fmsp.remove(ids).then(() =>{
      this.$message.success(this.$t('delete_success'))
      this.$emit('reload')
    })
  }

  deleteId(id){
    fmsp.remove(id).then(() =>{
      this.$message.success(this.$t('delete_success'))
      this.$emit('reload')
    })
  }

  openEdit(value){
    this.editData = value
    this.mmTitle = 'edit'
    this.creatVisible = true
  }

  reload(){
    this.creatVisible = false
    this.$emit('reload')
  }

  creat(){
    this.editData = {}
    this.mmTitle = 'create'
    this.creatVisible = true
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
  }

  render(){
    return(
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between; padding: 8px 8px 0 8px;">
          <div>
            <a-button type="primary" v-acl="page_system_coding_rules_application_object_creat" onClick={() => this.creat()} style="margin-right: 8px;">
              {this.$t('page_bill_classify_add')}
            </a-button>
            <a-popconfirm
              title={this.$t('delete_tips') + '?'}
              onConfirm={() => this.delete()}
            >
              <a-button
                type="danger"
                disabled={this.selectedRowKeys.length === 0}
                v-acl="page_system_coding_rules_application_object_delete"
                style="margin-right: 8px;"
              >{this.$t('delete')}</a-button>
            </a-popconfirm>
          </div>
          <div>
            <a-input-search style="width: 200px" placeholder={this.$t('keyword')} enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%;padding: 0 8px 8px">
          <ml-table
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            loading={this.loading}
            dataSource={this.data}
            rowSelection={{
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange,
              getCheckboxProps: this.getCheckboxProps
            }}
            columns={this.columns}
            scroll={{y: this.cilentHeight}}
            chooseArr={this.selectedRowKeys}
            onCancelChooseArr={this.cancelChooseArr}
          >
          </ml-table>
          <a-pagination
            style="position: absolute; right: 8px; bottom: 8px;"
            show-total={total => `${this.showTotal(total)}`}
            total={this.total}
            pageSize={this.filters.size}
            current={this.filters.current}
            onChange={this.pageIndexchange}
          ></a-pagination>
        </div>
        <creat-modal
          title={this.mmTitle}
          visible={this.creatVisible}
          editData={this.editData}
          onCancel={() => this.creatVisible = false}
          onSaveAll={() => this.reload()}
        ></creat-modal>
      </blank-view>
    )
  }
}
